const waveformCache = new Map();

/**
 * Возвращает стабильный fallback, чтобы аудиоплеер не прыгал при загрузке
 * и оставался читаемым, если браузер не смог декодировать файл
 */
export function emptyWaveformBars(count = 28) {
  return Array.from({ length: count }, (_, index) => 18 + ((index * 7) % 42));
}

/**
 * Строит реальные пики аудиофайла в браузере и кэширует promise по URL
 * один и тот же voice может встретиться в списке и модалке предпросмотра
 */
export async function getAudioWaveformBars(url, { barCount = 28 } = {}) {
  if (!url) return emptyWaveformBars(barCount);
  if (waveformCache.has(url)) return waveformCache.get(url);

  const promise = loadAudioWaveformBars(url, barCount).catch(() =>
    emptyWaveformBars(barCount)
  );
  waveformCache.set(url, promise);

  return promise;
}

/**
 * Нужен тестам и повторному входу в чат, чтобы сбросить browser-level cache util
 */
export function clearAudioWaveformCache() {
  waveformCache.clear();
}

/**
 * Загружает аудио и декодирует его через браузерный AudioContext
 */
async function loadAudioWaveformBars(url, barCount) {
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass || !window.fetch) return emptyWaveformBars(barCount);

  let audioContext = null;

  try {
    const response = await window.fetch(url);
    if (!response.ok) throw new Error(`Audio fetch failed: ${response.status}`);

    const buffer = await response.arrayBuffer();
    audioContext = new AudioContextClass();
    const audioBuffer = await audioContext.decodeAudioData(buffer);

    return audioBufferPeaks(audioBuffer, barCount);
  } finally {
    // На битом audio/decode браузер тоже держит AudioContext, поэтому закрываем
    // его в finally, а не только после успешного построения waveform
    await audioContext?.close?.();
  }
}

/**
 * Сжимает PCM-данные в фиксированное число столбиков для компактного UI voice
 */
function audioBufferPeaks(audioBuffer, barCount) {
  const channelData = audioBuffer.getChannelData(0);
  const samplesPerBar = Math.max(1, Math.floor(channelData.length / barCount));

  return Array.from({ length: barCount }, (_, index) => {
    const start = index * samplesPerBar;
    const end = Math.min(start + samplesPerBar, channelData.length);
    const slice = channelData.subarray(start, end);
    const peak = slice.reduce((max, sample) => Math.max(max, Math.abs(sample)), 0);

    return Math.max(12, Math.round(peak * 100));
  });
}
